import { CanActivateFn, Router } from '@angular/router';
import { Role } from '../common/enums/role.enum';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const user = authService.getUser();
  const roles = route.data?.['roles'] as Role[];
  const router = inject(Router);

  if (!user) {
    router.navigate(['home/user']);
    return false;
  }

  if (user.role === Role.SUPER_ADMIN) {
    return true;
  }

  if (user.role === Role.SUPERVISOR) {
    if (roles.includes(Role.SUPERVISOR)) {
      return true;
    }
  }

  if (user.role === Role.ADMIN) {
    if (roles.includes(Role.ADMIN)) {
      return true;
    }
  }

  authService.redirectByRole(user.role);
  return false;
};
